// Note 데이터 구조 (Firestore 저장용)
export interface NoteData {
  content: string;
  userId: string;
  pagePath: string;
  pageTitle: string;
  subject: string;
  lastSaved: Date | string;
  createdAt: Date | string;
}

// Note 목록 아이템 (필기 모음에서 사용)
export interface NoteListItem {
  id: string;
  content: string;
  pagePath: string;
  pageTitle: string;
  subject: string;
  lastSaved: string;
}

// 페이지 필터 드롭다운 옵션 (필기 모음 과목→페이지 종속 옵션, JCG-2126)
export type NotePageOption = Pick<NoteListItem, "pagePath" | "pageTitle">;

// localStorage에 저장할 노트 데이터
export interface LocalNoteData {
  content: string;
  lastLocalSaved?: string;
}

// API 응답 타입
export interface NoteSaveResponse {
  success: boolean;
  lastSaved?: string;
  error?: string;
}

export interface NoteGetResponse {
  note: NoteData | null;
  resetAt?: string | null;
  error?: string;
}

export interface NoteListResponse {
  notes: NoteListItem[];
  error?: string;
}

// 과목 매핑 (표시용)
export const SUBJECT_LABELS: Record<string, string> = {
  'db': '데이터베이스',
  'network-os': '네트워크/OS',
  'security-newtech': '보안/신기술',
  'sw-design': '소프트웨어 설계',
  'sw-dev': '소프트웨어 개발',
  'past-exam': '기출문제',
};

// 과목별 색상 (Tailwind CSS 클래스)
export const SUBJECT_COLORS: Record<string, string> = {
  'db': 'bg-blue-100 text-blue-700 dark:bg-blue-900 dark:text-blue-300',
  'network-os': 'bg-green-100 text-green-700 dark:bg-green-900 dark:text-green-300',
  'security-newtech': 'bg-red-100 text-red-700 dark:bg-red-900 dark:text-red-300',
  'sw-design': 'bg-purple-100 text-purple-700 dark:bg-purple-900 dark:text-purple-300',
  'sw-dev': 'bg-orange-100 text-orange-700 dark:bg-orange-900 dark:text-orange-300',
  'past-exam': 'bg-gray-200 text-gray-700 dark:bg-gray-700 dark:text-gray-300',
};

// 과목 정렬 순서 (past-exam이 가장 마지막)
export const SUBJECT_ORDER: string[] = ['db', 'network-os', 'security-newtech', 'sw-design', 'sw-dev', 'past-exam'];

// 과목 목록
export const SUBJECTS = Object.keys(SUBJECT_LABELS);
